import { render } from "./LogoOsSmall.vue?vue&type=template&id=1bd631b6"
const script = {}

import "./LogoOsSmall.vue?vue&type=style&index=0&id=1bd631b6&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__